import { combineReducers } from "redux";
import { cartReducer } from "./cartReducer";
import { wishlistReducer } from "./wishlistReducer";
import { userLoggedIn } from "./userLoggedIn";
import { headerReducer } from "./headerReducer";
import { filterReducer } from "./filterReducer";
import { orderReducer } from "./ordersReducer";
import { generalReducer } from "./generalReducer";
import { nbHitsCountReducer } from "./nbHitsCountReducer";
import { nostoReducer } from "./nostoReducer";
import { priceReducer } from "./priceReducer";
import { drawerReducer } from "./drawerReducer";
import { pwaReducer } from "./pwaReducer";
import oliCategoryReducer from "./oliCategoryReducer";
const reducer = combineReducers({
  click: cartReducer,
  wishlist: wishlistReducer,
  loginUser: userLoggedIn,
  header: headerReducer,
  filters: filterReducer,
  order: orderReducer,
  general: generalReducer,
  nbHitsCount: nbHitsCountReducer,
  nosto: nostoReducer,
  price: priceReducer,
  drawer: drawerReducer,
  pwa: pwaReducer,
  oliCategory: oliCategoryReducer,
});

export default reducer;
